import { ActivityStatus } from '.';
export function uuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
export function deepEqual(obj1, obj2) {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
}
export function copy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
export function toActivity(presentity) {
    if (typeof presentity.data.__lastInactivity === 'number') {
        return {
            status: ActivityStatus.IDLE,
            lastSeen: presentity.data.__lastInactivity,
        };
    }
    return {
        status: ActivityStatus.ACTIVE,
        lastSeen: null,
    };
}
//# sourceMappingURL=utils.js.map